<template>
  <h1>Advance Card</h1>
</template>

<script>
export default {
  name: "AdvanceCard",
};
</script>

<style scoped></style>
